module.exports = __webpack_public_path__ + "static/media/title-banner-3.057086ac.png";